var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language-button",style:(_vm.bodyCSS)},[_c('vp-button',{staticClass:"no-fill",attrs:{"id":"language-button__btn","styles":_vm.buttonStyles},on:{"click":function($event){return _vm.updateLanguage(_vm.toggleLanguage)}}},[_c('VpIcon',{attrs:{"icon":"globe"}}),_vm._v(" "+_vm._s(_vm.toggleLanguage)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }